import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rn1095: false
}

const ucSlice = createSlice({
  name: 'ucSlice',
  initialState,
  reducers: {
    setRn1095: (state, action) => {
      state.rn1095 = action.payload;
    }
  }
});

export const { setRn1095 } = ucSlice.actions;
export default ucSlice.reducer;